import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import ClientContainer from '../../ClientContainer';
import BannerStrip from '../../Common/Containers/BannerStrip';
import InvoicesItems from './InvoicesItems';
import useCloseDrawers from '../../../hooks/useCloseDrawers';
import useShowDetailsFromDashboard from '../../../hooks/useShowDetailsFromDashboard';
import InvoicesTable from './InvoicesTable/InvoiceTable';
import InvoicePaidSuccessPopup from './InvoicePaidSuccessPopup';
import { RootState } from '../../../../../redux/root';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';
import { ModalDefaultDraggable } from '../../../../../molecules';

const Invoices = () => {
  useCloseDrawers();
  useShowDetailsFromDashboard();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const value = queryParams.get('redirect_status') || '';
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const selectedProjectInvoice = useSelector((s: RootState) => s.fees.selectedProjectInvoice);

  const handleClose = () => dispatch(setShowDrawerContent(false));

  const title = selectedProjectInvoice?.projectPermit || 'Permit Invoices';

  return (
    <ClientContainer>
      {value === 'succeeded' && <InvoicePaidSuccessPopup isSuccess={value === 'succeeded'} />}
      <BannerStrip label="Invoices" />
      <TableStage>
        <InvoicesTable />
      </TableStage>
      {showDrawerContent && (
        <ModalDefaultDraggable title={title} onClose={handleClose} extraWide addContactModal>
          <InvoicesItems />
        </ModalDefaultDraggable>
      )}
    </ClientContainer>
  );
};

export default Invoices;

const TableStage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
